import {
    Component, 
    ViewChild, 
    Input
}  from "@angular/core";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";

import { Router } from "@angular/router";
import {FormControl} from "@angular/forms";
import {SelectionType} from "@swimlane/ngx-datatable";

import {BaseComponent, ActionDialog} from "app/base-module/base-component/base.component";

import { AuthService } from "app/base-module/base-service/auth.service";
import { ClienteIndicacaoService } from "../services/cliente-indicacao.service";
import { CadastroClienteIndicacaoComponent } from "../cadastro-cliente-indicacao/cadastro-cliente-indicacao.component";

@Component({
    selector: "app-lista-cliente-indicacao",
    templateUrl: "./lista-cliente-indicacao.component.html",
    styleUrls: ["./lista-cliente-indicacao.component.scss"],
    providers: []
})

export class ListaClienteIndicacaoComponent extends BaseComponent{
    
    user:any;
    public search = new FormControl();
SelectionType = SelectionType;

    selected = [];
    data:any = {};
    titulo!:string;

    model: any = {
        status_id: "",
        boletas:[]
    };

    _cliente_id:any = null;

    constructor(public service: ClienteIndicacaoService, 
                public dialog: MatDialog,
                override snackBar: MatSnackBar,
                private route: Router,
                private _authService: AuthService) {
        super(dialog, snackBar);

    }

    @Input() cliente_id!: number;

    ngOnInit() {
        const strUser = this._authService.getUser();
this.user = JSON.parse(strUser? strUser : "{}");
        this.search.setValue("");
        this.getAll();
       
    }

    /**
     * Evento de ordenação da lista
     * @param event
     */
    onSort(event:any){
        console.log(event);
    }

    /**
     * Evento da paginação
     * @param {PageEvent} event
     */
    pageEvent(event:PageEvent){

        this.params.page = (event.pageIndex+1);
        this.params.per_page = event.pageSize;

        this.getAll();
    }

    /**
     * Consulta lista
     */
    getAll() {
        if(this.search.value != null){
            this.params.search = this.search.value;
        }

        if(this.cliente_id != null && this.cliente_id != undefined){
            this.params.cliente_id = this.cliente_id;
        }

        this.loadingIndicator = true;
        this.service.getAll(this.params).subscribe(
            data => {
                this.length = data.meta.total;
                this.rows = data.data;
                this.temp = [...this.rows];
            },
            error => {                
                this.loadingIndicator = false;
                
                if(error.status == 401){        
                    this._authService.logout();
                    this.route.navigate(["/auth/login"]);
                }
            },
            () => {
                this.loadingIndicator = false;
            }
        );
    }

    /**
     * Exclui registro
     * @param id
     */
    delete(id: number) {

        const lista = this;
        this.dialog.open(ActionDialog, {
            width: "250px",
            disableClose: true,
            panelClass: "modal-delete",
            data: {
                title: "Excluir Indicação",
                text: "Deseja realmente excluir este item?",
                callback: function () {
                    lista.dialog.closeAll();

                    lista.loadingIndicator = true;
                    lista.service.delete(id).subscribe(
                        data => {
                            lista.loadingIndicator = false;
                            lista.showSuccess(data.message);
                            lista.getAll();
                        },
                        error => {
                            lista.loadingIndicator = false;
                            lista.showError(error.error.message);

                        },
                        () => {
                            lista.loadingIndicator = false;
                        }
                    );
                }
            }
        });
    }

    openCadastro(){
        const dialogRef = this.dialog.open(CadastroClienteIndicacaoComponent, {
            width: "500px",
            data: {
                acao_comercial_id: null,
                cliente_id: this.cliente_id,
                id: null
            }
        });

        dialogRef.afterClosed().subscribe((result: any) => {
            console.log(result);
            if (result != undefined && result != null && result != "cancel"){
                this.showSuccess("Indicação cadastrada com sucesso!");
                this.getAll();
            }else if(result != undefined && result != "cancel"){
                this.showError("Ocorreu um erro ao tentar cadastrar uma nova Indicação.");
            }
        });        
    }

    openAlterar(id:number){
        const dialogRef = this.dialog.open(CadastroClienteIndicacaoComponent, {
            width: "500px",
            data: {
                acao_comercial_id: null,
                cliente_id: this.cliente_id,
                id: id
            }
        });

        dialogRef.afterClosed().subscribe((result: any) => {
            console.log(result);
            if (result != undefined && result != null && result != "cancel"){
                this.showSuccess("Indicação atualizada com sucesso!");
                this.getAll();
            }else if(result != undefined && result != "cancel"){
                this.showError("Ocorreu um erro ao tentar alterar uma nova Indicação.");
            }
        });     
    }
}
